import ProfileContact from './ProfileContact.component';

export default ProfileContact;
